var _style, _path, _defs, _path2, _defs2, _defs3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlobMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 373.6 216.8",
    style: {
      enableBackground: "new 0 0 373.6 216.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000150104627698562076210000015306820111626891432_);}\n\t.st1{clip-path:url(#SVGID_00000131343162513601305270000002386960053038347673_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3,29.4c117.6-89.6,459.3,150.5,202.2,187.3C-51.8,222-43.3,118.9,74.3,29.4z M357.8,79.3C326,93.1,287,30.9,338.8,27 c31.8-2.6,47.8,38.7,22.2,50.4l-3,2"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 278.3,
    y: 0.2,
    transform: "matrix(1 -9.017811e-03 9.017811e-03 1 -0.1518 2.6782)",
    width: 37.2,
    height: 36
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030448245229409836090000011330452495500169125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030448245229409836090000011330452495500169125_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.6,9.5c-7.5,9.1-0.8,21.3,8.7,25.6c8.7,4,23.8-3.3,25.1-13.5c0.9-8.7-8.6-21.6-17.4-21.3c-4,0.1-12.1,2.1-14.7,7.1 L281.6,9.5"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058583421147608741710000003860696514420438702_",
    x: 72.1,
    y: 33.8,
    width: 15,
    height: 14.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086680689482462640890000004520193233528591261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058583421147608741710000003860696514420438702_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080924941583291511500000003499776134736268692_",
    x: 296.9,
    y: 41.7,
    width: 14,
    height: 13.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132079609077630082910000014408510850505274519_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080924941583291511500000003499776134736268692_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132079609077630082910000014408510850505274519_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.2,53.9c0.8,0.6,1.8,0.8,2.6,0.9h1.4c1-0.1,2-0.4,2.9-0.9l0.6-0.4c0.6-0.3,1-0.6,1.3-1l1-1.5c0.3-0.5,0.4-1,0.5-1.7 v-0.8l-0.1-0.7l-0.5-1.3l-0.7-1.3l-0.1-0.2c-0.6-1.1-1.5-2-2.6-2.6c-1.6-0.9-3.6-0.9-5.2,0l-0.5,0.3c-0.7,0.5-1.3,1.2-1.8,2 l-1,2.3l-0.2,1.3c0,1.5,0.3,3,1,4.3l0.5,0.6L300.2,53.9L300.2,53.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobMask);
export default __webpack_public_path__ + "static/media/blob-mask.ef60cfe242a50c73775ef5d6c556d127.svg";
export { ForwardRef as ReactComponent };